import { Resource,ResourceAttributes } from '@opentelemetry/resources';


let otelResource: Resource | undefined;


export const getResource = (): Resource => {
    if (!otelResource) {
      throw new Error('OTel Resource is not initialized. Call initResource first.');
    }
    return otelResource;
  };

  export type ResourceConfig = {

  }
export function initResource(params: ResourceAttributes) {
    otelResource = Resource.default().merge(
        new Resource(params),
    );
}